import { InboxModulePathType } from "@saysimple-platform/dtos";

export default [
    {
        title: `mainmenu.${InboxModulePathType.EMAIL}`,
        route: InboxModulePathType.EMAIL,
        icon: "envelope",
        resource: "emailInbox",
        action: "read",
    },
];
